<template>
  <div class="hero">
  </div>
</template>

<script>
export default {
  name: 'HeroSmall',
  components: {
  }
}
</script>

<style scoped>
  .hero{
    min-height:100px;
    position:relative;
    padding:15px;
    color:#fff;
  }
  .hero::before{
    content:"";
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-image: url('../../assets/bg.jpg');
    background-size:cover;
    background-position:50% 50%;
    background-attachment:fixed;
    opacity:1;
    z-index:-3;
  }
  .hero::after{
    content:"";
    position:absolute;
    background-color:#293339;
    opacity:0.8;
    top:0;
    right:0;
    bottom:0;
    left:0;
    z-index:-2;
  }

</style>